export default __webpack_public_path__ + "static/media/playwright.b9446af3.svg";